import { wirksamerTermin, type PlanungsVorhaben, type Termin } from '@netcon-work/shared'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { meilensteineQuery, vorhabenAllerWeltenQuery } from './queries'
import { useAufgabenAllerWelten } from './welt'

/**
 * **Der wirksame Termin jeder Aufgabe** – Fälligkeit → Meilenstein → Zieltermin → Zeitfenster
 * ([E-147](../../../../docs/ENTSCHEIDUNGEN.md#e-147), [E-281](../../../../docs/ENTSCHEIDUNGEN.md#e-281)).
 *
 * Für Kalender, „Gefährdet" und Circle (Z-20, 06.10.2026). Bis hierher kannten sie nur die
 * **Fälligkeit**: eine Aufgabe mit Zeitfenster „Jetzt" galt dort als eine ohne Termin, während der
 * Vorlauf sie als überfällig ganz nach vorn stellte. Dieselbe Rechnung wie in `lage.ts` – nicht
 * eine zweite, sondern dieselbe Funktion aus `shared` mit denselben Eingaben.
 *
 * Über alle Welten, wie der Bestand in „Mein Tag" (E-234, E-372).
 */
export function useWirksameTermine(): ReadonlyMap<string, Termin> {
  const { aufgaben } = useAufgabenAllerWelten()
  const { data: vorhaben = [] } = useQuery(vorhabenAllerWeltenQuery)
  const { data: meilensteine = [] } = useQuery(meilensteineQuery)
  return useMemo(() => {
    const heute = new Date()
    const vorhabenNachId = new Map<string, PlanungsVorhaben>(
      vorhaben.map((v) => [
        v.id,
        {
          id: v.id,
          zeitfenster: v.zeitfenster,
          zeitfensterAb: v.zeitfensterAb,
          zieltermin: v.zieltermin,
        },
      ]),
    )
    return new Map(
      aufgaben.map((a) => [a.id, wirksamerTermin(a, vorhabenNachId, meilensteine, heute)]),
    )
  }, [aufgaben, vorhaben, meilensteine])
}
